import React, { Component } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { withLocale } from 'react-localizer'

class LineContainerMain extends Component {

  constructor (props) {
    super(props)
    this.toggleHighlight = this.toggleHighlight.bind(this)

    /**
     * Set the hightLightedLevels
     */
    const isSethightLightedLevels = !!localStorage.getItem('hightLightedLevels')
    const hightLightedLevels =
      isSethightLightedLevels
        ? LineContainerMain.fromStringToSet(localStorage.getItem('hightLightedLevels'))
        : new Set()
    const highlight = isSethightLightedLevels ? hightLightedLevels.has(props.data.level.level) : false

    this.state = {
      highlight: highlight,
      arrLockable: props.data.arrLockable,
      level: props.data.level,
      hightLightedLevels: hightLightedLevels,
      promoteLevel: props.data.promoteLevel,
      notification: props.notification,
    }
  }

  /**
   * @param string
   * @returns {Set<any>}
   */
  static fromStringToSet (string) {
    let set = new Set()
    const array = string.split('-')
    for (let level of array) {
      set.add(parseInt(level, 10))
    }
    return set
  }

  /**
   * @param set
   * @returns {string}
   */
  static fromSetToString (set) {
    const array = Array.from(set)
    return array.join('-')
  }

  /**
   * Toggle the highlight of the line
   */
  toggleHighlight () {
    // if the hightlight is switch to TRUE we add it in the local storage

    //we first update the current hightLightedLevels
    const isSethightLightedLevels = !!localStorage.getItem('hightLightedLevels')
    let currentHightLightedLevels =
      isSethightLightedLevels
        ? LineContainerMain.fromStringToSet(localStorage.getItem('hightLightedLevels'))
        : new Set()

    if (!this.state.highlight) {
      currentHightLightedLevels.add(this.state.level.level)
    } else {
      //remove the line from the hightlighted levels
      currentHightLightedLevels.delete(this.state.level.level)
    }
    localStorage.setItem('hightLightedLevels', LineContainerMain.fromSetToString(currentHightLightedLevels))

    this.setState({
      highlight: !this.state.highlight,
      hightLightedLevels: currentHightLightedLevels
    })
  }

  /**
   * When composant receive new params
   * @param nextProps
   */
  componentWillReceiveProps (nextProps) {
    /**
     * Set the hightLightedLevels
     */
    const isSethightLightedLevels = !!localStorage.getItem('hightLightedLevels')
    const hightLightedLevels =
      isSethightLightedLevels
        ? LineContainerMain.fromStringToSet(localStorage.getItem('hightLightedLevels'))
        : new Set()
    const highlight = isSethightLightedLevels ? hightLightedLevels.has(nextProps.data.level.level) : false

    this.setState({
      highlight: highlight,
      hightLightedLevels: hightLightedLevels,
      arrLockable: nextProps.data.arrLockable,
      level: nextProps.data.level,
      promoteLevel: nextProps.data.promoteLevel,
    })
  }

  handleCopyChanged () {
    const promotionMessage = this.props.locale.get('gmBlockingThreshold.notification.promotionMessage', {variables:{ level: this.state.level.level}});
    this.state.notification(promotionMessage)
  }

  render () {
    return (
      <tr key={this.state.level.level}
          className={this.state.highlight ? 'highlight no_selection_on_dbl_click' : 'no_selection_on_dbl_click'}
          onClick={this.toggleHighlight}>
        <td className={'data-hj-allow'}>{this.state.level.level}</td>
        <td className={'data-hj-allow'}>{this.state.level.maxPf}</td>
        {this.state.arrLockable}
        <CopyToClipboard text={this.state.promoteLevel} onCopy={(event) => this.handleCopyChanged(event)}>
          <td><span className="glyphicon glyphicon-share iconCopyClipboard"/></td>
        </CopyToClipboard>
      </tr>
    )
  }
}

const LineContainer = withLocale(LineContainerMain)

export default LineContainer



// WEBPACK FOOTER //
// ./src/components/GmBlockingThreshold/LineContainer.js